// extracted by mini-css-extract-plugin
export default {"heading-primary":"ModalRenderer_heading-primary__jKiQa","modal":"ModalRenderer_modal__Hry6U","modal__container":"ModalRenderer_modal__container__zh85T"};